import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion, AnimatePresence } from 'framer-motion';
import { Utensils, GlassWater, Wind, Star, Plus } from 'lucide-react';
import { useCart } from '../context/CartContext';
const menuData = {
  food: {
    Appetizers: [{
      name: 'Crispy Fried Wings',
      price: '$16.50',
      desc: 'Seasoned, golden-fried wings with house dipping sauce Buffalo Jerk Thai Chili',
      image: 'https://cdn.magicpatterns.com/uploads/boDJpsVmqyQLcrBKNMtTeS/pexels-miro-vrlik-2651115-32067295.jpg'
    }, {
      name: 'Oxtail Egg Rolls',
      price: '$22.50',
      desc: 'Slow-braised oxtail wrapped and fried, served with HOF signature sauce',
      image: 'https://cdn.magicpatterns.com/uploads/3X4qBGPmk73NnRQUUkMoxB/image.png'
    }, {
      name: 'Street-Style Tacos',
      price: '$18.00',
      desc: 'Choice of protein, fresh garnishes, and house salsa',
      image: 'https://images.unsplash.com/photo-1551504734-5ee1c4a1479b?auto=format&fit=crop&q=80&w=800'
    }, {
      name: 'Firecracker Shrimp',
      price: '$18.00',
      desc: 'Crispy shrimp tossed in a spicy-sweet firecracker glaze',
      image: 'https://cdn.magicpatterns.com/uploads/n9CdfAaf7Fhf8sywCFc7q5/image.png'
    }, {
      name: 'Wings',
      price: '$16.00',
      image: 'https://cdn.magicpatterns.com/uploads/sXQFKmwf5vBRmNfXypNeUw/pexels-miro-vrlik-2651115-32067295.jpg'
    }, {
      name: 'Suya',
      price: '$19.99',
      image: 'https://cdn.magicpatterns.com/uploads/2mQo6wXxAB5QQX7jmw2Xhu/pexels-shardar-tarikul-islam-84327533-8973353.jpg'
    }],
    Sides: [{
      name: 'Jollof Rice',
      price: '$7.00',
      desc: 'West African spiced rice, aromatic and bold',
      image: 'https://cdn.magicpatterns.com/uploads/hg6NbiBz2VURS7K1Xa6ZKh/pexels-feyraz-18601877.jpg'
    }, {
      name: 'Fried Plantains',
      price: '$7.00',
      desc: 'Sweet, caramelized plantains',
      image: 'https://cdn.magicpatterns.com/uploads/8ggMiopGGdTPJSbesbXD5V/pexels-snappr-27556971.jpg'
    }, {
      name: 'Crispy Brussels Sprouts',
      price: '$7.00',
      desc: 'Crispy flash fried and finished with a light honey ginger glaze',
      image: 'https://cdn.magicpatterns.com/uploads/jddAtpHkbqbienNs82ZSoR/pexels-damir-mijailovic-1921088-5612342.jpg'
    }, {
      name: 'French Fries',
      price: '$6.00',
      desc: 'Crispy fries seasoned to perfection',
      image: 'https://cdn.magicpatterns.com/uploads/8WX3A9xaE3ZxvNzT4HnKxP/pexels-enginakyurt-8272619.jpg'
    }],
    Entrees: [{
      name: 'Signature Smash Burger',
      price: '$17.50',
      desc: 'Double-smashed beef patties with perfectly caramelized, crispy edges, layered with melted cheese, fresh lettuce, and ripe tomato on a toasted bun for a bold, crave-worthy bite.',
      image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?auto=format&fit=crop&q=80&w=800'
    }, {
      name: 'Crispy Chicken Sandwich & Fries',
      price: '$17.50',
      desc: 'Golden, crispy fried chicken breast served on a toasted bun with fresh lettuce, tomato, and creamy sauce, paired with a side of hot, perfectly salted fries',
      image: 'https://cdn.magicpatterns.com/uploads/xvzwEbL1zJYHHGHgUzftnF/pexels-rajdeepcraft-17119248-6416558.jpg'
    }, {
      name: 'Suya & Jollof Rice',
      price: '$28.00',
      desc: 'Smoky, spice-rubbed suya grilled to perfection and served over vibrant, tomato-rich jollof rice, creating a bold and flavorful West African classic.',
      image: 'https://cdn.magicpatterns.com/uploads/4VF1SQyCkvagqQJKhksdhn/pexels-keesha-s-kitchen-22731136-13915043.jpg'
    }, {
      name: 'Smash Burger And Fries',
      price: '$17.50',
      desc: 'Juicy, thin-pressed smash burger with crispy edges and melted cheese on a toasted bun, served alongside hot, golden fries for a classic comfort combo.',
      image: 'https://cdn.magicpatterns.com/uploads/993H5VmnqqLP9aWkJYLbZu/pexels-padrechaks-35991523.jpg'
    }],
    Desserts: [{
      name: 'Brown Butter Bundt Cake',
      price: '$10.00',
      desc: 'w bourbon Caramel sauce & Ice cream',
      image: 'https://images.unsplash.com/photo-1551024601-bec78aea704b?auto=format&fit=crop&q=80&w=800'
    }]
  },
  drinks: {
    'Bar Drinks': [{
      name: 'Casa Blanco',
      price: '$14.00'
    }, {
      name: 'Casa Reposado',
      price: '$16.00'
    }, {
      name: 'Ciroc',
      price: '$14.00'
    }, {
      name: 'Remy Vsop',
      price: '$16.00'
    }, {
      name: 'Henny',
      price: '$14.00'
    }, {
      name: 'Jameson',
      price: '$13.00'
    }, {
      name: "Jack Daniel's",
      price: '$13.00'
    }, {
      name: 'Black Label',
      price: '$13.00'
    }, {
      name: 'Macllan',
      price: '$18.00'
    }, {
      name: 'Glenficch',
      price: '$18.00'
    }, {
      name: 'Malibu',
      price: '$13.00'
    }, {
      name: 'Dusse',
      price: '$14.00'
    }, {
      name: '1738',
      price: '$18.00'
    }, {
      name: 'Vsop Henny',
      price: '$18.00'
    }, {
      name: 'Titos',
      price: '$12.00'
    }, {
      name: 'Don Julio Reposado',
      price: '$16.00'
    }, {
      name: 'Don Julio Blanco',
      price: '$14.00'
    }, {
      name: 'Grey Goose',
      price: '$12.00'
    }, {
      name: 'Patron',
      price: '$13.00'
    }, {
      name: 'Crown Royal',
      price: '$12.00'
    }, {
      name: 'Hendricks',
      price: '$13.00'
    }, {
      name: 'Tanqeray',
      price: '$13.00'
    }, {
      name: 'Rail',
      price: '$10.00'
    }, {
      name: 'Margarita',
      price: '$11.00',
      image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=800'
    }, {
      name: 'Magarita Top Shelf',
      price: '$16.00'
    }, {
      name: 'Long Island',
      price: '$13.00'
    }, {
      name: 'Long Island Top Shelf',
      price: '$16.00'
    }, {
      name: 'Lemon Drop',
      price: '$11.00',
      image: 'https://images.unsplash.com/photo-1556679343-c7306c1976bc?auto=format&fit=crop&q=80&w=800'
    }, {
      name: 'Rum Punch',
      price: '$10.00'
    }, {
      name: 'Termana',
      price: '$13.00'
    }, {
      name: 'Bacardi',
      price: '$13.00'
    }],
    Wine: [{
      name: 'Merlot',
      price: '$9.00'
    }, {
      name: 'Moscato',
      price: '$9.00'
    }, {
      name: 'Resling',
      price: '$9.00'
    }, {
      name: 'Wine Bottle',
      price: '$76.00'
    }],
    Beers: [{
      name: 'Heineken',
      price: '$6.00'
    }, {
      name: 'Guinness',
      price: '$7.00'
    }, {
      name: 'Corona',
      price: '$6.00'
    }],
    Soda: [{
      name: 'Ginger Ale',
      price: '$4.00'
    }, {
      name: 'Coke',
      price: '$4.00'
    }, {
      name: 'Red Bull',
      price: '$7.00'
    }, {
      name: 'Water',
      price: '$4.00'
    }, {
      name: 'Cranberry Juice',
      price: '$4.00'
    }, {
      name: 'Orange Juice',
      price: '$4.00'
    }, {
      name: 'Pineapple',
      price: '$4.00'
    }],
    'Bottle Service': [{
      name: "Tito's Bottle",
      price: '$202.00'
    }, {
      name: 'Cîroc Bottle',
      price: '$224.00'
    }, {
      name: 'Glen 12',
      price: '$286.00'
    }, {
      name: 'Grey Goose Bottle',
      price: '$300.00'
    }, {
      name: 'Casamigos Blanco Bottle',
      price: '$246.00'
    }, {
      name: 'Casamigos Reposado Bottle',
      price: '$286.00'
    }, {
      name: 'Don Julio Blanco Bottle',
      price: '$246.00'
    }, {
      name: 'Don Julio Reposado Bottle',
      price: '$302.00'
    }, {
      name: 'Patron Silver Bottle',
      price: '$246.00'
    }, {
      name: 'Don Julio 1942 Bottle',
      price: '$620.00'
    }, {
      name: 'Clase Azul Reposado Bottle',
      price: '$620.00'
    }, {
      name: 'Hennessy VS Regular Bottle',
      price: '$246.00'
    }, {
      name: 'Hennessy VSOP Bottle',
      price: '$286.00'
    }, {
      name: "D'Ussé VSOP Bottle",
      price: '$224.00'
    }, {
      name: "Jack Daniel's Bottle",
      price: '$186.00'
    }, {
      name: 'Jameson Bottle',
      price: '$186.00'
    }, {
      name: 'Remy 1738 Bottle',
      price: '$323.00'
    }, {
      name: 'Rose H Champagne',
      price: '$162.00'
    }, {
      name: 'Moët Nectar Bottle',
      price: '$246.00'
    }, {
      name: 'Moët Ice Bottle',
      price: '$224.00'
    }, {
      name: 'Veuve Clicquot Bottle',
      price: '$202.00'
    }, {
      name: 'Dom Pérignon Bottle',
      price: '$450.00'
    }, {
      name: 'Ace Of Spades Gold Bottle',
      price: '$680.00'
    }, {
      name: 'Glen 15',
      price: '$302.00'
    }, {
      name: 'Termana',
      price: '$241.94'
    }, {
      name: 'Mcallan 12',
      price: '$326.00'
    }, {
      name: 'Wycliff',
      price: '$80.00'
    }, {
      name: 'Moet Nectar Glow',
      price: '$286.00'
    }]
  },
  hookah: {
    Astronaut: [{
      name: 'Astronaut Hookah',
      price: '$100.00'
    }],
    'Comp Hookah': [{
      name: 'Comp Hookah Promoter',
      price: ''
    }],
    'Full Hookah': [{
      name: 'Love 66',
      price: '$60.00'
    }, {
      name: 'Blueberry Mint',
      price: '$60.00'
    }, {
      name: 'Lady Killer',
      price: '$60.00'
    }, {
      name: 'Mi Amor',
      price: '$60.00'
    }, {
      name: 'Watermelon',
      price: '$60.00'
    }, {
      name: 'Orange Mint',
      price: '$60.00'
    }, {
      name: 'Mint',
      price: '$60.00'
    }, {
      name: 'Vanilla',
      price: '$60.00'
    }, {
      name: 'Peach',
      price: '$60.00'
    }, {
      name: 'Skyfall',
      price: '$60.00'
    }, {
      name: 'Blue Mist',
      price: '$60.00'
    }, {
      name: 'Gum Mint',
      price: '$60.00'
    }, {
      name: 'Watermelon Mint',
      price: '$60.00'
    }, {
      name: 'Tropicool',
      price: '$60.00'
    }, {
      name: 'Lemon Mint',
      price: '$60.00'
    }, {
      name: 'Guava',
      price: '$60.00'
    }, {
      name: 'Mighty Freeze',
      price: '$60.00'
    }, {
      name: 'Strawberries',
      price: '$60.00'
    }, {
      name: 'Mango',
      price: '$60.00'
    }, {
      name: 'Grape Mint',
      price: '$60.00'
    }],
    'Hookah Refill': [{
      name: 'Blue Mist Refill',
      price: '$30.00'
    }, {
      name: 'Blueberry Mint Refill',
      price: '$30.00'
    }, {
      name: 'Grape Mint Refill',
      price: '$30.00'
    }, {
      name: 'Guava Refill',
      price: '$30.00'
    }, {
      name: 'Gum Mint Refill',
      price: '$30.00'
    }, {
      name: 'Lady Killer Refill',
      price: '$30.00'
    }, {
      name: 'Lemon Mint Refill',
      price: '$30.00'
    }, {
      name: 'Love 66 Refill',
      price: '$30.00'
    }, {
      name: 'Mango Refill',
      price: '$30.00'
    }, {
      name: 'Mi Amor Refill',
      price: '$30.00'
    }, {
      name: 'Mighty Freeze Refill',
      price: '$30.00'
    }, {
      name: 'Mint Refill',
      price: '$30.00'
    }, {
      name: 'Orange Mint Refill',
      price: '$30.00'
    }, {
      name: 'Peach Refill',
      price: '$30.00'
    }, {
      name: 'Skyfall Refill',
      price: '$30.00'
    }, {
      name: 'Strawberries Refill',
      price: '$30.00'
    }, {
      name: 'Tropicool Refill',
      price: '$30.00'
    }, {
      name: 'Vanilla Refill',
      price: '$30.00'
    }, {
      name: 'Watermelon Refill',
      price: '$30.00'
    }, {
      name: 'Watermelon Mint Refill',
      price: '$30.00'
    }]
  },
  specials: {
    'Table Packages': [{
      name: 'Silver',
      price: '$486.00'
    }, {
      name: 'Gold',
      price: '$606.00'
    }, {
      name: 'Diamond',
      price: '$807.00'
    }, {
      name: 'Platinum',
      price: '$1,212.00'
    }, {
      name: 'Bronze',
      price: '$326.00'
    }],
    'General Admission': [{
      name: 'Early Bird',
      price: '$20.00'
    }, {
      name: 'General Entry',
      price: '$30.00'
    }, {
      name: 'After Midnight',
      price: '$50.00'
    }, {
      name: 'Premium Entry',
      price: '$100.00'
    }],
    'Tues Drink Special': [{
      name: 'Green Tea Shooters',
      price: '$8.00'
    }, {
      name: 'Mexican Teas',
      price: '$8.00'
    }, {
      name: 'Lemon Drop Martinis',
      price: '$7.00'
    }, {
      name: 'Pornstar Martinis',
      price: '$10.00'
    }],
    'Thursday Drink Special': [{
      name: 'Rail Shots',
      price: '$10.00'
    }, {
      name: 'Green Tea Shooter',
      price: '$10.00'
    }, {
      name: 'Mexican Teas Rail',
      price: '$10.00'
    }, {
      name: 'Lemon Drop Martinis Rail',
      price: '$10.00'
    }, {
      name: 'Pornstar Martinis',
      price: '$10.00'
    }],
    Brunch: [{
      name: 'Bottomless Mimosa Ticket',
      price: '$56.00'
    }, {
      name: 'Brunch General Ticket',
      price: '$41.00'
    }, {
      name: 'Bottomless Glass',
      price: '$19.00'
    }]
  }
};
type TabType = 'food' | 'drinks' | 'hookah' | 'specials';
export function Menu() {
  const [activeTab, setActiveTab] = useState<TabType>('food');
  const {
    addItem
  } = useCart();
  const tabs = [{
    id: 'food',
    label: 'Food',
    icon: Utensils
  }, {
    id: 'drinks',
    label: 'Drinks',
    icon: GlassWater
  }, {
    id: 'hookah',
    label: 'Hookah',
    icon: Wind
  }, {
    id: 'specials',
    label: 'Specials',
    icon: Star
  }] as const;
  return <div className="min-h-screen bg-[#0B1014] text-white flex flex-col" data-id="element-1393">
      <Header data-id="element-1394" />

      {/* Hero Section */}
      <div className="relative pt-32 pb-16 overflow-hidden" data-id="element-1395">
        <div className="absolute inset-0 bg-gradient-to-b from-[#DDA247]/5 via-transparent to-transparent" data-id="element-1396" />
        <div className="absolute top-20 right-1/4 w-96 h-96 bg-[#DDA247]/10 rounded-full blur-[120px]" data-id="element-1397" />

        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-1398">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-3xl mx-auto text-center" data-id="element-1399">
            <h1 className="text-4xl md:text-6xl font-bold text-white uppercase tracking-tight mb-6 leading-tight" data-id="element-1400">
              Our Menu
            </h1>
            <p className="text-gray-400 text-base md:text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-1401">
              Explore our curated selection of bold flavors, premium drinks, and
              exclusive experiences.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Main Content */}
      <main className="flex-1 pb-20 px-4 md:px-6 container mx-auto max-w-5xl" data-id="element-1402">
        {/* Tabs */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-4 mb-12" data-id="element-1403">
          {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center gap-2 px-6 py-3 rounded-full font-bold uppercase tracking-wider transition-all duration-300 ${activeTab === tab.id ? 'bg-[#DDA247] text-[#0B1014]' : 'bg-[#1A2228] text-gray-400 hover:text-white hover:bg-[#2A343D]'}`} data-id="element-1404">
              <tab.icon className="w-4 h-4" data-id="element-1405" />
              {tab.label}
            </button>)}
        </div>

        {/* Menu Content */}
        <AnimatePresence mode="wait" data-id="element-1406">
          <motion.div key={activeTab} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.3
        }} className="space-y-16" data-id="element-1407">
            {Object.entries(menuData[activeTab]).map(([category, items]) => <div key={category} data-id="element-1408">
                <div className="flex items-center gap-4 mb-8" data-id="element-1409">
                  <h2 className="text-2xl md:text-3xl font-bold text-white uppercase tracking-wide" data-id="element-1410">
                    {category}
                  </h2>
                  <div className="flex-1 h-px bg-gradient-to-r from-[#DDA247]/50 to-transparent" data-id="element-1411" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-6" data-id="element-1412">
                  {items.map((item, index) => <div key={index} className="group p-4 rounded-2xl hover:bg-white/5 transition-colors duration-300 flex gap-4 relative" data-id="element-1413">
                      {item.image && <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-xl overflow-hidden shadow-lg border border-white/10" data-id="element-1414">
                          <img src={item.image} alt={item.name} className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500" data-id="element-1415" />
                        </div>}
                      <div className="flex-1 flex flex-col justify-center" data-id="element-1416">
                        <div className="flex justify-between items-baseline mb-2 gap-4" data-id="element-1417">
                          <h3 className="text-lg font-bold text-white group-hover:text-[#DDA247] transition-colors" data-id="element-1418">
                            {item.name}
                          </h3>
                          {item.price && <>
                              <div className="flex-1 border-b border-dashed border-white/20 relative top-[-4px]" data-id="element-1419" />
                              <span className="text-[#DDA247] font-bold whitespace-nowrap" data-id="element-1420">
                                {item.price}
                              </span>
                            </>}
                        </div>
                        {item.desc && <p className="text-sm text-gray-400 leading-relaxed pr-8" data-id="element-1421">
                            {item.desc}
                          </p>}
                        {item.price && <div className="mt-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-1422">
                            <button onClick={() => {
                      addItem({
                        id: `${category}-${item.name.replace(/\s+/g, '-').toLowerCase()}`,
                        type: 'menu',
                        title: item.name,
                        price: parseFloat(item.price.replace(/[^0-9.]/g, '')),
                        image: item.image,
                        quantity: 1
                      });
                    }} className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#DDA247] hover:text-white transition-colors" data-id="element-1423">
                              <Plus className="w-3.5 h-3.5" data-id="element-1424" />
                              Add to Cart
                            </button>
                          </div>}
                      </div>
                    </div>)}
                </div>
              </div>)}
          </motion.div>
        </AnimatePresence>
      </main>

      <Footer data-id="element-1425" />
    </div>;
}